import type { ReactNode } from 'react'
import { Link } from '@/components/site/link'
import { cn } from 'cn'
import { buttonVariants } from '@/components/ui/button'

type SectionLink = {
  href: string
  label: string
  variant?: 'default' | 'outline'
}

/**
 * The standard section container of the new design language:
 * label eyebrow → title → subtitle, optional head action (right-aligned)
 * and optional centered CTA below the content.
 */
export function SiteSection({
  id,
  label,
  title,
  subtitle,
  action,
  cta,
  className,
  children,
}: {
  id?: string
  label?: string
  title?: string
  subtitle?: string
  action?: SectionLink
  cta?: SectionLink
  className?: string
  children: ReactNode
}) {
  return (
    <section className={cn('home-section', className)} id={id}>
      {label || title || subtitle || action ? (
        <div className={cn('home-section-head', action && 'home-section-head--split')}>
          <div className="home-section-head-text">
            {label ? <p className="home-section-label">{label}</p> : null}
            {title ? <h2 className="home-section-title">{title}</h2> : null}
            {subtitle ? <p className="home-section-subtitle">{subtitle}</p> : null}
          </div>
          {action ? (
            <Link
              href={action.href}
              className={cn(
                buttonVariants({ variant: action.variant || 'outline' }),
                'home-btn-section home-section-action',
              )}
            >
              {action.label} →
            </Link>
          ) : null}
        </div>
      ) : null}
      {children}
      {cta ? (
        <div className="home-section-cta">
          <Link
            href={cta.href}
            className={cn(
              buttonVariants({ variant: cta.variant || 'outline' }),
              'home-btn-section',
            )}
          >
            {cta.label} →
          </Link>
        </div>
      ) : null}
    </section>
  )
}
